import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  form p {
    font-size: 1.25rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--ink-faint);
    margin-top: 2.4rem;
  }

  h1 {
    margin-bottom: 3rem;
  }
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 0;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 2.5rem;
  gap: 3rem;

  @media (max-width: 800px) {
    flex-direction: column-reverse;
  }
`;

export { Container, InputContainer, ButtonsContainer };
